import { QUESTION_TYPES } from './constants';

export default survey => {
  const surveyTemp = survey;

  /* eslint-disable no-param-reassign */
  // Remove GraphQL __typename keyword
  if (survey && survey.content) {
    let totalQuestionFlows = 0;
    const groupIds = survey.content.groups.map(g => g.id);

    totalQuestionFlows += survey.content.groups.reduce((acc, group) => {
      const questionsPerGroup = group.flows.reduce(
        (acc2, f) => (groupIds.indexOf(f) === -1 ? acc2 + 1 : acc2),
        0
      );

      return acc + questionsPerGroup;
    }, 0);

    totalQuestionFlows += survey.content.flows.reduce(
      (acc, f) => (groupIds.indexOf(f) === -1 ? acc + 1 : acc),
      0
    );

    delete survey.content.__typename;

    // Check if total number of question flows is different than number of questions to show error message
    if (totalQuestionFlows !== surveyTemp.questions.length) {
      return false;
    }
  }

  const questions =
    surveyTemp.questions &&
    Array.isArray(surveyTemp.questions) &&
    surveyTemp.questions.reduce((acc, q) => {
      if (q && q.choices && q.choices.length) {
        q.choices = q.choices.map(c => {
          delete c.__typename;
          return c;
        });
      }

      if (q && q.branches && q.branches.length) {
        q.branches = q.branches.map(b => {
          delete b.__typename;

          if (b.range && b.range.__typename) {
            delete b.range.__typename;
          }

          return b;
        });
      }

      delete q.__typename;

      return {
        ...acc,
        [q.id]: q
      };
    }, {});
  /* eslint-enable no-param-reassign */

  // Distributor groups should always have nextFlow set
  const distributorQuestions = Object.values(questions).filter(
    q => q.type === QUESTION_TYPES.DISTRIBUTOR
  );

  let distributorGroupsError = false;
  // eslint-disable-next-line array-callback-return
  distributorQuestions.map(q => {
    const branchGroups = q.branches.map(b => b.nextFlow);

    if (survey && survey.content && survey.content.groups) {
      const distributorGroups = survey.content.groups.filter(
        g => branchGroups.indexOf(g.id) > -1
      );

      if (
        distributorGroups &&
        distributorGroups.length &&
        distributorGroups.some(g => !g.nextFlow && !g.end)
      ) {
        distributorGroupsError = true;
      }
    }
  });

  if (distributorGroupsError) {
    return false;
  }

  return { surveyTemp, questions };
};
